import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getAlerts, deleteAlert, getUsersList, getWorkstationsList, subscribeToAlert } from '../../../../redux/actions'

// Project created tools
import { keyify2 } from '../../../../utils'
import { Toast as NotificationToast, ConfirmToast } from '../../tools'
import TabPanel from '../../tools/TabPanel'

// MUI
import {
  Grid, Paper, Typography, Checkbox, Button, Chip,
  Tabs, Tab
} from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/core/styles'

// Tab Imports
import LSPrefAlerts from './LSPrefAlerts'
import OrgAlerts from './OrgAlerts'
import UserOnlyAlerts from './UserOnlyAlerts'
import UserBuildAlerts from './UserBuildAlerts'
import CloneAlerts from './CloneAlerts'

import log from 'loglevel'

const useStyles = makeStyles((theme) => ({
  accordionroot: {
    width: '100%'
  },
  AccSumm: {
    marginBottom: '0px !important',
    justifyContent: 'space-between'
  },
  chipStyle: {
    backgroundColor: '#A4D164',
    color: '#f5f5f5',
    height: '19px',
    verticalAlign: 'bottom'
  },
  accdetails: {
    alignItems: 'center'
  },
  heading: {
    textTransform: 'none',
    fontWeight: 'bold'
  },
  secondaryHeading: {
    textTransform: 'none',
    fontSize: '12px',
    marginTop: '0px',
    marginBottom: '10px',
    color: '#9e9e9e'
  },
  manageButton: {
    textTransform: 'none',
    borderColor: '#5291fc',
    color: '#5291fc'
  },
  accDeets: {
    flexDirection: 'row',
    paddingTop: '0px !important',
    display: 'flex'
  },
  saveButton: {
    backgroundColor: '#5291fc',
    color: '#FFFFFF',
    padding: theme.spacing(2, 1),
    maxHeight: '3em',
    fontWeight: 'bold',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#719E31'
    }
  },
  blueButton: {
    backgroundColor: '#5291fc',
    color: '#FFFFFF',
    maxHeight: '3em',
    fontWeight: 'bold',
    textTransform: 'none'
  },
  activeTabStyle: {
    fontWeight: 'bold',
    textTransform: 'none'
  },
  inactiveTabStyle: {
    textTransform: 'none'
  },
  tabs: {
    color: '#5291fc !important'
  },
  tabIndicator: {
    backgroundColor: '#5291fc'
  },
  dialogContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  unitIcon: {
    marginTop: '3px',
    paddingTop: '3px'
  },
  greenText: {
    color: '#97b557'
  },
  blueText: {
    color: '#007BFF'
  },
  listRoot: {
    width: '100%',
    position: 'relative',
    overflow: 'auto',
    maxHeight: 75,
    marginBottom: '10px'
  },
  listItemText: {
    marginTop: 0,
    marginBottom: 0
  },
  listItem: {
    paddingLeft: '0px'
  },
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    }
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
    padding: '1em'
  },
  inputInput: {
    padding: theme.spacing(2, 1, 2, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(5)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%'
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#868787',
    // '&:hover': {
    //   backgroundColor: fade('#868787', 0.25)
    // },
    width: '100%'
  },
  contentGridShow: {
  },
  contentGridHide: {
    maxHeight: '0px',
    transition: '0.5s',
    overflow: 'hidden'
  },
  unitTree: {
    width: 'fit-content',
    marginLeft: '-0.5em'
  },
  errorText: {
    color: '#fc0303'
  },
  alertBtn: {
    color: '#9e9e9e',
    padding: theme.spacing(0.25)
  },
  subscribeBtn: {
    padding: theme.spacing(0.25),
    color: '#97b557'
  },
  unsubscribeBtn: {
    padding: theme.spacing(0.25),
    color: '#007BFF'
  },
  fixSpacing: {
    width: '100%',
    margin: 'auto'
  }
}))

const GreenCheckbox = withStyles({
  root: {
    color: '#595959',
    '&$checked': {
      color: '#A4D164'
    }
  },
  checked: {}
})((props) => <Checkbox color='default' {...props} />)

const UserMgmtAlerts = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const TreeData = useSelector(state => state.auth.unitTree)
  const Permissions = useSelector(state => state.auth.permissions)
  const Alerts = useSelector(state => state.alerts.alerts)
  const settings = useSelector(state => state.orgSettingsSettings.general)
  const UserSettings = useSelector(state => state.userSettings.general)

  // This is used to determine if the Org has disbled LearnSafe Preferred alerts
  const [lspDisabled, setLSPDisabled] = useState(false)

  // This is used to determine if the Org has disabled SMS
  const [smsDisabled, setSMSDisabled] = useState(false)

  // This allows for whether or not the Global setting is set for this Org
  const [tabSwap, setTabSwap] = useState('LSP')

  const newUnitInfo = {
    global: [],
    supervisor: [],
    unit: [{
      accountID: '',
      application: false,
      author: '',
      categories: [],
      createdDate: null,
      clonedAlert: false,
      emailNotificationDesc: '',
      emailNotificationID: '',
      emailNotificationName: '',
      keyboard: true,
      maxSeverity: 100,
      minSeverity: 1,
      privateAlert: false,
      subscribed: {
        sendEmail: false,
        sendSMS: false,
        isSubscribed: false
      },
      type: '',
      unitID: '',
      users: [],
      words: [],
      workstations: []
    }]
  }

  // This is currently being used to capture the unit tree information to get the alerts
  const data = keyify2(TreeData)
  const [selectedKeys] = useState(data)

  // This state item is currently hard coded and will need to be brough in from redux
  const [unitAlertInfo, setUnitAlertInfo] = useState(newUnitInfo)

  // This is required for the tabs to properly set
  const [value, setValue] = useState(0)
  const [formSwap, setFormSwap] = useState('Manage-Alerts')

  const [editing, setEditing] = useState(false)
  const [editData, setEditData] = useState()
  const [editAlertID, setEditAlertID] = useState()
  const [userSMSEnabled, setUserSMSEnabled] = useState(false)

  // Clone alert state items
  const [cloneAlertID, setCloneAlertID] = useState()

  // Bring in information from API to populate Alerts
  useEffect(() => {
    (async () => {
      dispatch(getAlerts(selectedKeys[0]))

      if (settings) {
        if (!settings.enableLSAlerts) {
          setLSPDisabled(true)
          setTabSwap('Org')
          setValue(1)
        }
        if (!settings.enableSMS) {
          setSMSDisabled(true)
        }
      }
      if (UserSettings) {
        if (UserSettings.enableSMS) {
          setUserSMSEnabled(true)
        }
      }
    }
    )()
  }, [dispatch, settings, selectedKeys, UserSettings])

  useMemo(() => { if (Alerts) { setUnitAlertInfo(Alerts) } }, [Alerts])

  const [noSMS, setNoSMS] = useState(false)

  useEffect(() => {
    if (smsDisabled || !userSMSEnabled) {
      setNoSMS(true)
    } else if (!smsDisabled || userSMSEnabled) {
      setNoSMS(false)
    }
  }, [smsDisabled, userSMSEnabled])

  // Allows for overly long titles
  const truncateText = (input) => {
    if (input.length > 45) {
      return input.substring(0, 45) + '...'
    }
    return input
  }

  // Gets the total number of subscribed alerts and total number of alerts available, this is for the chip item in the UI
  const getSubscriptionNumber = (unitAlertInfo) => {
    if (
      unitAlertInfo && Array.isArray(unitAlertInfo.unit) &&
      Array.isArray(unitAlertInfo.global) && Array.isArray(unitAlertInfo.supervisor)
    ) {
      const subscribed = []
      const total = unitAlertInfo.unit.length + unitAlertInfo.global.length + unitAlertInfo.supervisor.length

      unitAlertInfo.unit.forEach((unitInfo) => {
        if (unitInfo && unitInfo.subscribed && Boolean(unitInfo.subscribed.isSubscribed)) {
          subscribed.push(unitInfo)
        }
      })

      unitAlertInfo.global.forEach((unitInfo) => {
        if (unitInfo && unitInfo.subscribed && Boolean(unitInfo.subscribed.isSubscribed)) {
          subscribed.push(unitInfo)
        }
      })

      unitAlertInfo.supervisor.forEach((unitInfo) => {
        if (unitInfo && unitInfo.subscribed && Boolean(unitInfo.subscribed.isSubscribed)) {
          subscribed.push(unitInfo)
        }
      })

      return (`${subscribed.length} of ${total}`)
    }

    return 'None Available'
  }

  // handles the user deleting an alert
  const handleDelete = async (unitID, emailNotificationID, orgAlert) => {
    // awaits a confirmation toast
    const deleteAlerts = await ConfirmToast({ msg: 'Are You Sure?', txt: ' This will permanently delete this Alert, and cannot be undone.' })
    if (deleteAlerts === true) {
      dispatch(deleteAlert(unitID, emailNotificationID, orgAlert, fireDeleteSuccess, fireDeleteFailure))
      dispatch(getAlerts(selectedKeys[0]))
    }
  }
  const fireDeleteSuccess = () => {
    NotificationToast(false, 'Successfully deleted Alert!')
    dispatch(getAlerts(selectedKeys[0]))
  }

  const fireDeleteFailure = () => {
    NotificationToast(true, 'Failed to Delete Alert.')
  }

  const fireSubscribeSuccess = () => {
    NotificationToast(false, 'Successfully Updated Alert Preferences!')
    dispatch(getAlerts(selectedKeys[0]))
  }

  const fireSubscribeFailure = () => {
    NotificationToast(true, 'Failed to update alert Preferences.')
  }

  // This handles the tab render and checks for the global state boolean
  const handleChange = (event, newValue) => {
    setValue(newValue)
    if (newValue === 0 && !lspDisabled) {
      setTabSwap('LSP')
    }
    if (newValue === 1) {
      setTabSwap('Org')
    }
    if (newValue === 2) {
      setTabSwap('User')
    }
  }

  useEffect(() => {
    dispatch(getUsersList())
    dispatch(getWorkstationsList())
  }, [dispatch])

  const formDataSet = (unit) => {
    setFormSwap('New-Alert')
    setEditAlertID(unit.emailNotificationID)
    setEditData(unit)
  }

  const formCloneSwap = (alertID) => {
    log.debug(alertID)
    setFormSwap('Clone-Alert')
    setCloneAlertID(alertID)
  }

  // comes back to the manage alerts page and resets the edit information
  const handleBacktrack = () => {
    setFormSwap('Manage-Alerts')
    setEditing(false)
    setEditData()
    setEditAlertID()
    setCloneAlertID()
    dispatch(getAlerts(selectedKeys[0]))
  }

  const unSubscribeAlert = (notificationID) => {
    const unitsToDelete = []
    if (Alerts.global.findIndex(x => x.emailNotificationID === notificationID) !== -1) {
      Alerts.global.forEach((alert) => {
        if (alert.emailNotificationID === notificationID) {
          alert.subscribed.units.forEach((unit) => {
            unitsToDelete.push(unit.unitID)
          })
        }
      })
    }
    if (Alerts.supervisor.findIndex(x => x.emailNotificationID === notificationID) !== -1) {
      Alerts.supervisor.forEach((alert) => {
        if (alert.emailNotificationID === notificationID) {
          alert.subscribed.units.forEach((unit) => {
            unitsToDelete.push(unit.unitID)
          })
        }
      })
    }
    if (Alerts.unit.findIndex(x => x.emailNotificationID === notificationID) !== -1) {
      Alerts.unit.forEach((alert) => {
        if (alert.emailNotificationID === notificationID) {
          alert.subscribed.units.forEach((unit) => {
            unitsToDelete.push(unit.unitID)
          })
        }
      })
    }
    const unitID = selectedKeys[0]
    const Preferences = {
      emailNotificationID: notificationID,
      unitsToAdd: [],
      unitsToDelete: unitsToDelete,
      sendSMS: false,
      sendEmail: false,
      isSubscribed: false
    }
    dispatch(subscribeToAlert(unitID, Preferences, fireUnSubscribeSuccess, fireUnSubscribeFailure))
  }
  const fireUnSubscribeSuccess = () => {
    NotificationToast(false, 'Successfully Updated Alert Preferences!')
    dispatch(getAlerts(selectedKeys[0]))
  }

  const fireUnSubscribeFailure = () => {
    NotificationToast(true, 'Failed to update alert Preferences.')
  }

  // The container for the alert tabs
  const FormSwap = () => {
    switch (formSwap) {
      case 'Manage-Alerts':
        return (
          <>
            <Grid container item direction='row'>
              <Grid container item xs={6} direction='row' justify='flex-start'>
                <Grid container item direction='column'>
                  <Grid item container direction='row'>
                    <Typography component='h5' variant='h5' className='font-weight-bold'>Available Alerts:</Typography>
                  </Grid>

                  <Grid item container direction='row' spacing={2} className='mx-auto w-100' alignItems='center'>
                    <Grid item className='pl-0'>
                      <Typography variant='subtitle1' style={{ color: '#545454' }}>Currently Subscribed:</Typography>
                    </Grid>

                    <Grid item className='pr-0'>
                      <Chip label={getSubscriptionNumber(unitAlertInfo)} classes={{ root: classes.chipStyle }} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container item xs={6} direction='row' justify='flex-end'>
                <Grid item>
                  {
                    Permissions.findIndex((permissionKey) => permissionKey === 'alert-editor') !== -1
                      ? (
                        <Button
                          variant='contained'
                          size='small'
                          className={`${classes.saveButton}`}
                          onClick={() => setFormSwap('New-Alert')}
                        >
                          Create New Alert
                        </Button>
                      ) : (
                        <></>
                      )
                  }
                </Grid>
              </Grid>
            </Grid>

            <Grid container item direction='row' className='pt-0'>
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor='primary'
                textColor='primary'
                // variant='scrollable'
                // scrollButtons='auto'
                classes={{ indicator: classes.tabIndicator }}
              >
                {
                  !lspDisabled
                    ? (<Tab className={tabSwap === 'LSP' ? classes.activeTabStyle : classes.inactiveTabStyle} classes={{ textColorPrimary: classes.tabs }} label='LearnSafe Preferred Alerts' />)
                    : (<Tab style={{ display: 'none' }} />)
                }
                <Tab className={tabSwap === 'Org' ? classes.activeTabStyle : classes.inactiveTabStyle} classes={{ textColorPrimary: classes.tabs }} label='Organizational Alerts' />
                <Tab className={tabSwap === 'User' ? classes.activeTabStyle : classes.inactiveTabStyle} classes={{ textColorPrimary: classes.tabs }} label='My Alerts' />
              </Tabs>
            </Grid>

            <Grid container item direction='row'>
              <TabPanel index='LSP' value={tabSwap} className='w-100'>
                <LSPrefAlerts
                  classes={classes}
                  unitAlertInfo={unitAlertInfo}
                  setUnitAlertInfo={setUnitAlertInfo}
                  GreenCheckbox={GreenCheckbox}
                  TreeData={TreeData}
                  truncateText={truncateText}
                  selectedKeys={selectedKeys}
                  fireSubscribeSuccess={fireSubscribeSuccess}
                  fireSubscribeFailure={fireSubscribeFailure}
                  unSubscribeAlert={unSubscribeAlert}
                  noSMS={noSMS}
                  formCloneSwap={formCloneSwap}
                />
              </TabPanel>

              <TabPanel index='Org' value={tabSwap} className='w-100'>
                <OrgAlerts
                  setFormSwap={setFormSwap}
                  classes={classes}
                  unitAlertInfo={unitAlertInfo}
                  GreenCheckbox={GreenCheckbox}
                  truncateText={truncateText}
                  handleDelete={handleDelete}
                  formDataSet={formDataSet}
                  TreeData={TreeData}
                  formCloneSwap={formCloneSwap}
                  selectedKeys={selectedKeys}
                  fireSubscribeSuccess={fireSubscribeSuccess}
                  fireSubscribeFailure={fireSubscribeFailure}
                  setEditing={setEditing}
                  lspDisabled={lspDisabled}
                  noSMS={noSMS}
                  unSubscribeAlert={unSubscribeAlert}
                />
              </TabPanel>

              <TabPanel index='User' value={tabSwap} className='w-100'>
                <UserOnlyAlerts
                  setFormSwap={setFormSwap}
                  classes={classes}
                  unitAlertInfo={unitAlertInfo}
                  GreenCheckbox={GreenCheckbox}
                  truncateText={truncateText}
                  handleDelete={handleDelete}
                  formDataSet={formDataSet}
                  TreeData={TreeData}
                  selectedKeys={selectedKeys}
                  fireSubscribeSuccess={fireSubscribeSuccess}
                  fireSubscribeFailure={fireSubscribeFailure}
                  setEditing={setEditing}
                  lspDisabled={lspDisabled}
                  noSMS={noSMS}
                  unSubscribeAlert={unSubscribeAlert}
                />
              </TabPanel>
            </Grid>

            {/* Commented out until a final decision is made to handle the changes from an individual setting or through a batch */}
            {/* TODO: need to create an alert to make sure they have saved before navigating away from this page */}
            {/* <Grid container className='mt-2' style={{ justifyContent: 'flex-end' }}> */}
            {/* Does this need to be in each tab instead?? */}
            {/* <Button variant='contained' className={classes.saveButton} onClick={handleSubmit}> Save </Button> */}
            {/* </Grid> */}
          </>
        )
      case 'New-Alert':
        // The information to set to create or edit an alert
        return (
          <UserBuildAlerts
            setFormSwap={setFormSwap}
            unitAlertInfo={unitAlertInfo}
            value={value}
            setValue={setValue}
            editing={editing}
            editData={editData}
            setEditData={setEditData}
            editAlertID={editAlertID}
            setEditAlertID={setEditAlertID}
            handleBacktrack={handleBacktrack}
          />
        )
      case 'Clone-Alert':
        // Creating a new alert using information from an existing LSP alert
        return (
          <CloneAlerts
            selectedKeys={selectedKeys}
            cloneAlertID={cloneAlertID}
            classes={classes}
            editing={editing}
            editData={editData}
            setEditData={setEditData}
            setFormSwap={setFormSwap}
            editAlertID={editAlertID}
            setEditAlertID={setEditAlertID}
            handleBacktrack={handleBacktrack}
          />
        )
      default:
        return (<></>)
    }
  }

  return (
    <Grid container direction='row'>
      <Grid container item direction='column'>
        <Grid container item direction='row'>
          <Grid item>
            <h2 className='mr-3 mb-4'>Alert Manager</h2>
          </Grid>
        </Grid>

        <Grid container direction='row' justify='center'>
          <Grid item xs={12}>
            <Paper elevation={2}>
              <Grid container direction='row'>
                <Grid container item direction='column' justify='center' className='px-3 w-100 py-3 mx-auto my-auto' spacing={2}>
                  <FormSwap />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default UserMgmtAlerts
